import { render, staticRenderFns } from "./AttendanceDefinitionSettings.vue?vue&type=template&id=08b199a0&"
import script from "./AttendanceDefinitionSettings.vue?vue&type=script&lang=js&"
export * from "./AttendanceDefinitionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports